import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function ActionTakenReport() {
    const reports = [
        { year: '2023-24', area: 'Library Services', feedback: 'Students requested longer library hours.', action: 'Library hours extended to 6 PM on weekdays.', status: 'Implemented' },
        { year: '2023-24', area: 'Internet Connectivity', feedback: 'Poor Wi-Fi in classrooms.', action: 'Additional Wi-Fi access points installed in building B.', status: 'Implemented' },
        { year: '2022-23', area: 'Teaching Methods', feedback: 'More practical/lab sessions requested.', action: 'Lab timetable revised to include additional practical hours.', status: 'Implemented' },
        { year: '2022-23', area: 'Canteen Facilities', feedback: 'Hygiene and quality concerns.', action: 'New canteen vendor empanelled; regular quality checks initiated.', status: 'Implemented' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Feedback › Action Taken Report</p>
                <h1>Action Taken Report</h1>
                <p>Actions taken by the college based on stakeholder feedback.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About ATR</h2>
                    <p>The Action Taken Report (ATR) documents how the institution has responded to feedback from students, parents, teachers, alumni, and employers. It demonstrates the college's commitment to continuous improvement as mandated by NAAC and IQAC guidelines.</p>
                </div>
                <div className="info-card">
                    <h2>Action Taken</h2>
                    <table className="data-table">
                        <thead><tr><th>Year</th><th>Area</th><th>Feedback</th><th>Action Taken</th><th>Status</th></tr></thead>
                        <tbody>
                            {reports.map((r, i) => (
                                <tr key={i}>
                                    <td>{r.year}</td>
                                    <td style={{ fontWeight: 600 }}>{r.area}</td>
                                    <td>{r.feedback}</td>
                                    <td>{r.action}</td>
                                    <td style={{ color: '#2d6a4f', fontWeight: 700 }}>✅ {r.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default ActionTakenReport;
